import axios from "axios"
import { Data } from "~/types/dataTypes"

export function submitSurvey(data: Data) {
  return axios.post("/", data).then((response) => response.data)
}
